module.exports = __webpack_public_path__ + "static/media/course-successfully-bought.0d3a09e9.svg";